import { useEffect, useState } from "react";
import { ArrowRight, Phone } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { COMPANY } from "./data";
import { requestOffer } from "./scroll";
import { Pic } from "./Pic";

const KEY = "cb-offer-shown";

export const ExitOffer = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return undefined;
    let timer = 0;
    const cleanup = () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
    };
    const trigger = () => {
      const typing = ["INPUT", "TEXTAREA"].includes(document.activeElement?.tagName);
      if (sessionStorage.getItem("cb-sent") || sessionStorage.getItem(KEY)) return cleanup();
      if (typing || !localStorage.getItem("cb-consent")) return undefined;
      sessionStorage.setItem(KEY, "1");
      setOpen(true);
      return cleanup();
    };
    function onScroll() {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= 0.6) trigger();
    }
    timer = setTimeout(trigger, 40000);
    window.addEventListener("scroll", onScroll, { passive: true });
    return cleanup;
  }, []);

  useEffect(() => {
    if (open) window.__lenis?.stop();
    else window.__lenis?.start();
  }, [open]);

  const claim = () => {
    setOpen(false);
    setTimeout(() => requestOffer("Dachcheck & Beratung"), 250);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-lenis-prevent className="max-w-[calc(100%-1.5rem)] gap-0 overflow-hidden rounded-none border-white/10 bg-ink2 p-0 text-white sm:max-w-lg [&>button]:rounded-full [&>button]:bg-ink/70 [&>button]:p-2 [&>button]:text-white [&>button]:opacity-100" data-testid="exit-offer">
        <div className="relative h-36 sm:h-44">
          <Pic name="roofer" alt="Dachdecker bei der Arbeit auf einem Ziegeldach" sizes="512px" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink2 to-transparent" />
          <span className="absolute bottom-3 left-6 rounded-full bg-emerald-500 px-3 py-1 text-xs font-bold uppercase tracking-[0.12em] text-white sm:left-9">0 € · unverbindlich</span>
        </div>
        <div className="p-6 sm:p-9">
          <DialogTitle className="font-display text-[2.1rem] font-bold uppercase leading-[0.95] sm:text-4xl">
            Bevor Sie gehen: <span className="text-terra">Gratis-Dachcheck sichern</span>
          </DialogTitle>
          <DialogDescription className="mt-3 text-base text-slate-300">
            1 Klick, 0 Euro. Besichtigung innerhalb von 48 Stunden – mit Fotodokumentation und verbindlichem Festpreisangebot.
          </DialogDescription>
          <div className="mt-7 flex flex-col gap-3">
            <button type="button" onClick={claim} className="btn-primary btn-mega justify-center" data-testid="exit-offer-cta">Gratis-Dachcheck sichern <ArrowRight size={18} className="btn-arrow" /></button>
            <a href={COMPANY.phoneHref} className="btn-ghost justify-center" data-testid="exit-offer-phone"><Phone size={18} /> Lieber anrufen: {COMPANY.phoneDisplay}</a>
            <button type="button" onClick={() => setOpen(false)} className="mt-1 text-sm font-semibold text-slate-400 underline-offset-4 hover:text-white hover:underline" data-testid="exit-offer-close">Nein danke, ich schaue mich weiter um</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
